import { render, staticRenderFns } from "./WineTypeUpdate.vue?vue&type=template&id=38c40594"
import script from "./WineTypeUpdate.vue?vue&type=script&lang=ts"
export * from "./WineTypeUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports